import {makeAutoObservable} from "mobx";

export default class ItemsStore {
    constructor() {
        this._items = [
            // {title: 'Свеча', category_response: {title: 'Свечи'}, id: 1, description: 'тест тест тест', price: 1000 , count: 5, images:[]},
            // {title: 'Большая свеча', category_response: {title: 'Свечи'}, id: 2, description: 'тест тест тест', price: 1500 , count: 5, images:[]},
            // {title: 'Маленькая свеча', category_response: {title: 'Свечи'}, id: 3, description: 'тест тест тест', price: 700 , count: 5, images:[]},
            // {title: 'Саше-плитка', category_response: {title: 'Саше'}, id: 4, description: 'тест тест тест', price: 300 , count: 5, images:[]},
            // {title: 'Саше-лапки', category_response: {title: 'Саше'}, id: 5, description: 'тест тест тест', price: 400 , count: 5, images:[]},
            // {title: 'Аромадиффузор', category_response: {title: 'Диффузоры'}, id: 6, description: 'тест тест тест', price: 1200 , count: 5, images:[]},
            // {title: 'Пламенегаситель', category_response: {title: 'Аксессуары'}, id: 7, description: 'тест тест тест', price: 500 , count: 5, images:[]},
        ];
        this._categories = [];
    makeAutoObservable(this)
    }

    setItems(items) {
        this._items = items;
    }

    setCategories(categories) {
        this._categories = categories;
    }

    get items(){return this._items;}
    get categories() {return this._categories;}
}